module.exports = __webpack_public_path__ + "components/rewards/intersport/static/logo-c9496a0f66eb6e376c4cdd46d9f0ee1e.webp";